module.exports = __webpack_public_path__ + "img/home.ce4e96c2.svg";